export { toolbarVariables as toolbarMenuVariables } from './toolbarVariables';
